import {
  parts
} from "./chunk-HQZ4KMNS.mjs";
import {
  dom
} from "./chunk-L66JAUU2.mjs";

// src/dialog.connect.ts
function connect(state, send, normalize) {
  const ariaLabel = state.context["aria-label"];
  const isOpen = state.matches("open");
  const rendered = state.context.renderedElements;
  return {
    /**
     * Whether the dialog is open
     */
    isOpen,
    /**
     * Function to open the dialog
     */
    open() {
      send("OPEN");
    },
    /**
     * Function to close the dialog
     */
    close() {
      send("CLOSE");
    },
    triggerProps: normalize.button({
      ...parts.trigger.attrs,
      id: dom.getTriggerId(state.context),
      "aria-haspopup": "dialog",
      type: "button",
      "aria-expanded": isOpen,
      "aria-controls": dom.getContentId(state.context),
      onClick() {
        send("TOGGLE");
      }
    }),
    backdropProps: normalize.element({
      ...parts.backdrop.attrs,
      hidden: !isOpen,
      id: dom.getBackdropId(state.context)
    }),
    containerProps: normalize.element({
      ...parts.container.attrs,
      hidden: !isOpen,
      id: dom.getContainerId(state.context),
      style: {
        pointerEvents: isOpen ? void 0 : "none"
      }
    }),
    contentProps: normalize.element({
      ...parts.content.attrs,
      role: state.context.role,
      hidden: !isOpen,
      id: dom.getContentId(state.context),
      tabIndex: -1,
      "aria-modal": true,
      "aria-label": ariaLabel || void 0,
      "aria-labelledby": ariaLabel || !rendered.title ? void 0 : dom.getTitleId(state.context),
      "aria-describedby": rendered.description ? dom.getDescriptionId(state.context) : void 0
    }),
    titleProps: normalize.element({
      ...parts.title.attrs,
      id: dom.getTitleId(state.context)
    }),
    descriptionProps: normalize.element({
      ...parts.description.attrs,
      id: dom.getDescriptionId(state.context)
    }),
    closeTriggerProps: normalize.button({
      ...parts.closeTrigger.attrs,
      id: dom.getCloseTriggerId(state.context),
      type: "button",
      onClick(event) {
        event.stopPropagation();
        send("CLOSE");
      }
    })
  };
}

export {
  connect
};
